import { Box, Checkbox, Divider, FormControlLabel, Link } from "@mui/material";
import Text from "@/components/Text";
import {
  NOTE_PREVIEW_DIVIDER_COLOR,
  NOTE_PREVIEW_LABELS,
  NOTE_PREVIEW_SIDEBAR_WIDTH_PX,
} from "../note-preview-constant";
import { NotePreviewSection } from "../note-preview-types";

export interface IncludeInReportPanelProps {
  sections: NotePreviewSection[];
  areAllSelected: boolean;
  isSelected: (key: string) => boolean;
  onToggle: (key: string) => void;
  onSelectAll: () => void;
  onClearAll: () => void;
}

/** Left-hand checklist of the note's sections; the paper shows only the ticked ones. */
const IncludeInReportPanel = ({
  sections,
  areAllSelected,
  isSelected,
  onToggle,
  onSelectAll,
  onClearAll,
}: IncludeInReportPanelProps) => (
  <Box
    component="aside"
    sx={{
      width: NOTE_PREVIEW_SIDEBAR_WIDTH_PX,
      flexShrink: 0,
      alignSelf: "flex-start",
      position: "sticky",
      top: 0,
      bgcolor: "#FFFFFF",
      border: `1px solid ${NOTE_PREVIEW_DIVIDER_COLOR}`,
      borderRadius: 2,
      p: 2,
      display: "flex",
      flexDirection: "column",
      gap: 0.5,
    }}
  >
    <Text size={15} fontWeight="bold">
      {NOTE_PREVIEW_LABELS.includeInReport}
    </Text>
    <Link
      component="button"
      type="button"
      underline="hover"
      sx={{ alignSelf: "flex-start", fontSize: 13, mb: 1 }}
      onClick={areAllSelected ? onClearAll : onSelectAll}
    >
      {areAllSelected
        ? NOTE_PREVIEW_LABELS.clearAll
        : NOTE_PREVIEW_LABELS.selectAll}
    </Link>
    <Divider sx={{ mb: 1 }} />
    {sections.length === 0 && (
      <Text size={13} c="text.secondary">
        {NOTE_PREVIEW_LABELS.noSections}
      </Text>
    )}
    {sections.map((section) => (
      <FormControlLabel
        key={section.key}
        sx={{ m: 0, alignItems: "flex-start" }}
        control={
          <Checkbox
            size="small"
            sx={{ py: 0.25 }}
            checked={isSelected(section.key)}
            onChange={() => onToggle(section.key)}
          />
        }
        label={
          <Text size={13} sx={{ pt: 0.4 }}>
            {section.title}
          </Text>
        }
      />
    ))}
  </Box>
);

export default IncludeInReportPanel;
